/* HydrojenBottle — variant picker + quantity stepper.
   Progressive enhancement only: snippets/hjb-buy-form.liquid is a working
   product form on its own, so a failure here degrades to a normal form post. */
(function () {
  'use strict';

  function initPanel(panel) {
    if (panel.dataset.hjbBound === '1') return;
    panel.dataset.hjbBound = '1';

    var dataEl = panel.querySelector('[data-hjb-variants]');
    if (!dataEl) return;

    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var idInput = panel.querySelector('[data-hjb-id]');
    var priceEl = panel.querySelector('[data-hjb-price]');
    var compareEl = panel.querySelector('[data-hjb-compare]');
    var addBtn = panel.querySelector('[data-hjb-add]');
    var addText = panel.querySelector('[data-hjb-add-text]');
    var fieldsets = panel.querySelectorAll('[data-hjb-option-index]');

    function selectedOptions() {
      var out = [];
      fieldsets.forEach(function (fs) {
        var checked = fs.querySelector('input[type=radio]:checked');
        out[Number(fs.dataset.hjbOptionIndex)] = checked ? checked.value : null;
      });
      return out;
    }

    function matchVariant(opts) {
      return variants.find(function (v) {
        return opts.every(function (o, i) { return v.options[i] === o; });
      });
    }

    function update() {
      var v = matchVariant(selectedOptions());
      if (!v) return;

      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = v.price_formatted;

      if (compareEl) {
        if (v.compare_at && Number(v.compare_at) > Number(v.price)) {
          compareEl.textContent = v.compare_at_formatted;
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }

      if (addBtn) addBtn.disabled = !v.available;
      if (addText) addText.textContent = v.available ? 'Add to cart' : 'Sold out';

      // Keep the URL shareable and let a reload restore the same variant.
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url);
      }

      // Move the gallery to this variant's image when the section renders one.
      if (v.media_id) {
        var gallery = document.querySelector('[data-hjb-gallery]');
        if (gallery) {
          var target = gallery.querySelector('[data-hjb-media-id="' + v.media_id + '"]');
          if (target) target.click();
        }
      }
    }

    fieldsets.forEach(function (fs) {
      fs.addEventListener('change', update);
    });

    panel.querySelectorAll('[data-hjb-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = panel.querySelector('#hjb-qty');
        if (!input) return;
        var next = (parseInt(input.value, 10) || 1) + Number(btn.dataset.hjbQty);
        input.value = Math.min(99, Math.max(1, next));
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-hjb-buy]').forEach(initPanel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
